<div class="khts-inline-notification-error">
    <span class="material-symbols-outlined khts-inline-notification-error__icon"> error </span>
    <span>
        <ng-content></ng-content>
    </span>
</div>
